import { gql } from 'apollo-angular';
import { DownloadOptionalParameters } from '../catalog-graphql.service';

const DOWNLOAD_PRODUCT_ATTRIBUTES = (
  downloadParams: DownloadOptionalParameters,
) => {
  return gql`
query downloadProductAttributes {
  downloadProductAttributes(
      ${
        downloadParams.categorizationSchemeId
          ? 'categorizationSchemeId:' + downloadParams.categorizationSchemeId
          : ''
      }
      ${
        downloadParams.categoryId
          ? 'categoryId:' + downloadParams.categoryId
          : ''
      }
      ${
        downloadParams.searchValue
          ? 'searchValue:' + '"' + downloadParams.searchValue + '"'
          : ''
      }
  )
}
`;
};

export default DOWNLOAD_PRODUCT_ATTRIBUTES;
